import React from "react";
import DivTable from "../../components/divTable";
import {faCloudUploadAlt, faSmileWink, faUpload} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import IconTitle from "../../components/iconTitle";
import MyFile from "../../components/myFile";
import {toast} from "react-toastify";

class UploadDocument extends ScreenComponent {

    constructor(props) {
        super(props);

        this.state = {
            documents: []
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Documents}`);

        this.setState({
            documents: body.sort((a, b) => a.Title > b.Title ? 1 : -1)
        });
    }

    click(item) {
        item.ref.click();
    }

    async save(item, id) {
        await Post(`/v1/extranet/student/${screens.Documents}`, {
            DocumentID: id,
            DocumentDossierEtudiantID: item.ID
        }, {toastID: toast.info("Sauvegarde en cours", {autoClose: false})}, {render: "Fichier sauvegardé !"}, {render: "Erreur lors de la sauvegarde du fichier"});

        if (item.Title.includes("photo d'identité")) {
            await Post(`/v1/files/${id}/updatePicture`, {}, {toastID: toast.info("Mise à jour de la photo", {autoClose: false})}, {render: "Photo mise à jour !"}, {render: "Erreur lors de la sauvegarde de la photo"});
        }

        this.componentDidMount();
        document.querySelector('.file-loading').remove();
    }

    render() {
        return (
            <section>
                <IconTitle icon={faUpload} type={"h3"} content={"Fichiers à charger"}/>
                {this.state.documents.length > 0 ?
                    <DivTable columns={{
                        'Type du fichier': 'Title',
                        'Message informatif': 'Message',
                        'Actions': (item) => {
                            return <div className={'actions'}>
                                <FontAwesomeIcon icon={faCloudUploadAlt}
                                                 style={{
                                                     color: "#da2c97",
                                                     fontSize: "3.5rem",
                                                     padding: "0.5rem",
                                                     cursor: "pointer"
                                                 }}
                                                 onClick={this.click.bind(this, item)}/>
                                <div style={{display: 'none'}}>
                                    <MyFile name={"ID"}
                                            accept={item.Title.includes("photo d'identité") ? "image/png,image/jpg,image/jpeg" : "application/pdf,image/png,image/jpg,image/jpeg"}
                                            inputRef={(r) => item.ref = r}
                                            onChange={(id) => this.save(item, id)}
                                            label={null}/>
                                </div>
                            </div>;
                        }
                    }}
                              array={this.state.documents}/> :
                    <div style={{marginLeft: "4.5rem"}}><IconTitle type={"h6"} classContent={"ml-1 pl-1"}
                                                                   icon={faSmileWink} content={"Tout est en ordre"}/>
                    </div>}
            </section>
        );
    }
}

export default withRouter(UploadDocument);